import { Box } from "@mui/material";

const TalentBlacklistedIcon = () => {
  const blacklistIcon = "⚫️";
  return (
    <Box display="flex" alignItems="center" gap="5px">
      <Box component="span" fontSize="16px" lineHeight="24px">
        {blacklistIcon}
      </Box>
    </Box>
  );
};

export default TalentBlacklistedIcon;
